var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"text-capitalize font-cl font-weight-bold",staticStyle:{"background":"#E2E2E2"},attrs:{"fab":"","small":"","loading":_vm.loading,"depressed":""},on:{"click":function($event){return _vm.$emit('on-click')}}},[_c('v-icon',[_vm._v("mdi-arrow-down")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }